import { useEffect } from 'react';

/**
 * GA4 loader. Injects the gtag.js script when REACT_APP_GA4_ID is set.
 * Renders nothing. Safe no-op when env var is missing or in dev.
 */
export default function GoogleAnalytics() {
  useEffect(() => {
    const id = process.env.REACT_APP_GA4_ID;
    if (!id) return;
    if (typeof window === 'undefined') return;
    if (window.__ga4_loaded) return;
    window.__ga4_loaded = true;

    // Inject gtag loader
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', id, { send_page_view: true });
  }, []);

  return null;
}
